import m from "../../geodata/es2015/australiaLow";
window.am4geodata_australiaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/australiaLow.js
// module id = null
// module chunks = 